import axios from "axios";
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from "react";
import { API } from "../utils/net-api";
import { useLocalStorage } from '@uidotdev/usehooks';
import { OffsetLimit } from '../parts/offset-limit';

export default function CommentPage({ navigate, waveID }) {
    const [rows, setRows] = useState()
    const [token] = useLocalStorage('token')

    const loadData = (offset, limit) => {
        axios.post(API.comments.replace('waveID', waveID),
            { limit: limit, offset: offset },
            { headers: { 'Authorization': `Bear ${token}` } })
            .then((res) => {
                if (res.status !== 200) {
                    alert(`Get users is Error`);
                    return;
                }
                if (!res.data.Succeed) {
                    alert(res.data.Message);
                    return;
                }
                const data = res.data.Data
                setRows(data);
            })
            .catch((error) => {
                alert(`Get users is ${error}`)
            })
    }

    if (!rows) {
        loadData(0, 100);
    }

    const columns = [
        { field: 'ID', headerName: 'ID', width: 75 },
        { field: 'CommentToID', headerName: 'TO ID', width: 75 },
        { field: 'Content', headerName: 'Content', width: 625 },
        { field: 'User', headerName: 'User', valueGetter: (value, row) => { return !row.User ? row.UserID : row.User.FirstName }, width: 150 },
        { field: 'CreatedAt', headerName: 'Create', valueGetter: (value, row) => row.CreatedAt.substring(0, 10), width: 75 },
    ];

    const paginationModel = { page: 0, pageSize: 5 };

    return (
        <div>
            <OffsetLimit hasBack={true} onBack={navigate} title='Comment:' onComfirm={loadData} />
            <Paper sx={{ height: 600, width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5, 10]}
                    getRowId={(row) => row.ID}
                    sx={{ border: 0 }}
                />
            </Paper>
        </div>
    );
}

CommentPage.propTypes = {
    navigate: PropTypes.func.isRequired,
    waveID: PropTypes.number.isRequired,
};